<template>
<div class="chapter">
<div class="inner_page">
<div id="GEQB-EBNative-2.html" xml:lang="en-US">
<div class="story">
<h2 id="toc_marker-2"><a id="Anchor-5">ABOUT THIS BOOK</a></h2><a id="Anchor-5">
<p class="first">The recipes in this book were selected from 25 years of the Chicago Tribune’s best food reporting. Several of the recipes were created in the Tribune test kitchen. Many of the recipes include nutrition information to aid in menu planning.</p>
</a></div><a id="Anchor-5">
</a></div><a id="Anchor-5">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GEQBEBNative2.vue?e7f76790